import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class PropertyService {
  static async update(id, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PROPERTY_UPDATE(
          $id: String!
          $data: PropertyInput!
        ) {
          propertyUpdate(id: $id, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
      },
    });

    return response.data.propertyUpdate;
  }

  static async destroyAll(ids) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PROPERTY_DESTROY($ids: [String!]!) {
          propertyDestroy(ids: $ids)
        }
      `,

      variables: {
        ids,
      },
    });

    return response.data.propertyDestroy;
  }

  static async create(id, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PROPERTY_CREATE( $id: String! $data: PropertyInput!) {
          propertyCreate(id: $id, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
      },
    });

    return response.data.propertyCreate;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PROPERTY_IMPORT(
          $data: PropertyInput!
          $importHash: String!
        ) {
          propertyImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.propertyImport;
  }

  static async find(id) {
    const response = await graphqlClient.query({
      query: gql`
        query PROPERTY_FIND($id: String!) {
          propertyFind(id: $id) {
            id
            name
            status
            access
            sport
            country
            type
            maxNumSubproperty
            emails
            walletEnabled
            logos {
              id
              name
              type
              sizeInBytes
              publicUrl
              privateUrl
            }
            managers {
              id
              email
              fullName
            }
            subproperty {
              id
              birthdateType
              country
              dateFormat
              timeFormat
            }
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
      },
    });
    return response.data.propertyFind;
    
  }

  static async dashboard(id) {
    const response = await graphqlClient.query({
      query: gql`
        query PROPERTY_DASHBOARD($id: String!) {
          propertyDashboard(id: $id) {
            stats {
              type
              amount
            }
          }
        }
      `,

      variables: {
        id,
      },
    });
    return response.data.propertyDashboard;
  }

  static async requirementSteps(propertyId, userId) {
    const response = await graphqlClient.query({
      query: gql`
        query PROPERTY_REQUIREMENT_STEPS($propertyId: String!, $userId: String!) {
          propertyRequirementSteps(propertyId: $propertyId, userId: $userId) {
            steps {
              key
              done
              active
            }
          }
        }
      `,

      variables: {
        propertyId,
        userId
      },
    });
    return response.data.propertyRequirementSteps;
  }

  static async newId() {
    const response = await graphqlClient.query({
      query: gql`
        query PROPERTY_NEW_ID {
          propertyNewId
        }
      `,
    });
    return response.data.propertyNewId;
  }

  static async list(filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query PROPERTY_LIST(
          $filter: PropertyFilterInput
          $orderBy: PropertyOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          propertyList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              name
              status
              access
              sport
              country
              type
              maxNumSubproperty
              walletEnabled
              managers {
                id
                email
                fullName
                avatars {
                  publicUrl
                }
              }
              logos {
                id
                name
                type
                sizeInBytes
                publicUrl
                privateUrl
              }
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.propertyList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query PROPERTY_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          propertyAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.propertyAutocomplete;
  }
}
